
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Fügen Sie es zu Ihrem Startbildschirm hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.`,
's224cbcec014ef6b5': `Drücken Sie auf Teilen in der Navigationsleiste`,
's37a9e8aec5713460': `Mehr`,
's386eca8362ff6155': `Drücken Sie auf Mehr, wenn kein Teilen-Symbol vorhanden ist`,
's4e1e10a6ca408245': `Tippen Sie auf "Zum Startbildschirm hinzufügen"`,
's6196153c4b0c1ea0': `Installieren`,
's633502f7cff4f847': `Öffnen Sie das Menü Ihres Browsers`,
's681e399d63311fba': `Galerie anzeigen`,
's7f0591f08e318eda': `Drücken Sie auf Mehr im Teilen-Menü`,
's8114bd55cae5a22b': `Drücken Sie auf Zum Dock hinzufügen`,
's922329d6f6213590': `Zum Dock hinzufügen`,
's9af56bf005b49c74': `Scrollen Sie nach unten zu "Zum Startbildschirm hinzufügen"`,
'sa5ef80b4bb9b39f8': `Weniger`,
'sba52286c21552a4e': `Installieren Sie es auf Ihrem Gerät für eine umfassende Erfahrung und einen leichten Zugriff.`,
'sc16e00a7a8b2fde2': `Zurück`,
'scdaf4bbff76674c8': `Hinzufügen zum Startbildschirm`,
'se0e473adfda8066c': `Öffnen Sie es in Ihrem Hauptbrowser`,
'se740f75b95a51807': `Fügen Sie es zu Ihrem Dock hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.`,
'sfea652f6580ff086': `Diese Website verfügt über App-Funktionalität.`,
    };
  